// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { API_BASE_URL } from "../../../../utils/index";
// import BackArrow from "../../../../components/MinorComponents/BackArrow";
// import { Modal, Button, Form } from "react-bootstrap";
// import TextField from "@mui/material/TextField";
// import FormLabel from "@mui/material/FormLabel";
// function CategorysDetial( show, handleClose,) {
//   const { _id } = useParams();
  
//   const [data, setdata] = useState({});
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getsinglecategory/${_id}`)
//       .then((response) => {
//         console.log(response.data.data); // Check the structure of response.data.data
//         setdata(response.data.data); // Set categoryname state
//       })
//       .catch((error) => {
//         console.error("Error fetching category:", error);
//       });
//   }, [_id]); // Ensure to include _id in the dependency array to fetch data on _id change
  
//   return (
//     // <div className="p-4 text-center mt-5 card w-25 m-auto">
//     //   <div className="cartitle">

      
//     //   <h4 >Category Details</h4>
//     //   <h6>Name:</h6>
//     //   <p>{data.categoryname}</p>
//     //   <h6>createdAt</h6>
//     //   <p>{data.updatedAt
//     //   }</p>
//     //   <BackArrow path="/category" /> Back
//     //   </div>
//     // </div>
//     <Modal show={show} onHide={handleClose} >
//     <Modal.Header closeButton>
//       <Modal.Title className="text-center">
//         <h5 className="text-center ms-5">Type Details</h5>
//       </Modal.Title>
//     </Modal.Header>
//     <h4 >Category Details</h4>
//     <h6>Name:</h6>
//      <p>{data.categoryname}</p>
//       <h6>createdAt</h6>
//       <p>{data.updatedAt
//       }</p>
//        <BackArrow path="/category" /> Back
//   </Modal>
//   );
// }

// export default CategorysDetial;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../../utils/index";
import { Modal } from "react-bootstrap";
import BackArrow from "../../../../components/MinorComponents/BackArrow";

function CategorysDetial({ show, handleClose, categoryId }) {
  const [data, setData] = useState({});

  useEffect(() => {
    if (categoryId) {
      axios
        .get(`${API_BASE_URL}/getsinglecategory/${categoryId}`)
        .then((response) => {
          setData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching category:", error);
        });
    }
  }, [categoryId]);

  return (  
    <Modal show={show} onHide={handleClose}>
     <Modal.Header className="text-center" >
          <Modal.Title className="m-auto fw-bold " >
            Type Details
          </Modal.Title>
        </Modal.Header>
      <Modal.Body className=" ">
        <div className="background p-2 bg-warning  border-start-0 rounded text-center opacity-75">

        <h6 className="fs-5 fw-bold">Type</h6>
        <p className="text-white ">{data.categoryname}</p>
        </div>
       
      </Modal.Body>
      <Modal.Footer className="m-auto">
<span onClick={handleClose}>

        <BackArrow path="/category"  /> Back
</span>
      </Modal.Footer>
    </Modal>
  );
}

export default CategorysDetial;
